"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2987],{

/***/ 31554:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgCalendarIcon = function SvgCalendarIcon(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    width: "512pt",
    height: "512pt",
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M179.97 201.09a8.964 8.964 0 0 0-6.34 15.3 8.96 8.96 0 0 0 9.77 1.942 8.964 8.964 0 0 0 5.535-8.281c0-4.95-4.016-8.961-8.965-8.961zM239.62 210.05a8.965 8.965 0 1 1-17.93 0c0-4.95 4.016-8.96 8.965-8.96s8.965 4.01 8.965 8.96M290.31 210.05a8.965 8.965 0 1 1-17.93 0c0-4.95 4.016-8.96 8.965-8.96s8.965 4.01 8.965 8.96M332.03 201.09a8.964 8.964 0 0 0-6.34 15.3 8.963 8.963 0 0 0 9.77 1.942 8.961 8.961 0 0 0-3.43-17.242zM179.97 243.72a8.962 8.962 0 0 0-8.281 5.535 8.97 8.97 0 0 0 1.941 9.77 8.967 8.967 0 0 0 15.305-6.34c0-4.95-4.016-8.965-8.965-8.965zM239.62 252.68c0 4.95-4.016 8.965-8.965 8.965s-8.965-4.016-8.965-8.965c0-4.95 4.016-8.965 8.965-8.965s8.965 4.016 8.965 8.965M290.31 252.68c0 4.95-4.016 8.965-8.965 8.965s-8.965-4.016-8.965-8.965c0-4.95 4.016-8.965 8.965-8.965s8.965 4.016 8.965 8.965M332.03 243.72a8.962 8.962 0 0 0-8.281 5.535 8.97 8.97 0 0 0 1.941 9.77 8.97 8.97 0 0 0 9.77 1.941 8.965 8.965 0 0 0-3.43-17.246zM179.97 286.36a8.964 8.964 0 1 0 8.965 8.965 8.965 8.965 0 0 0-8.965-8.965zM239.62 295.32c0 4.95-4.016 8.96-8.965 8.96s-8.965-4.01-8.965-8.96a8.965 8.965 0 1 1 17.93 0M290.31 295.32c0 4.95-4.016 8.96-8.965 8.96s-8.965-4.01-8.965-8.96a8.965 8.965 0 1 1 17.93 0M332.03 286.36a8.964 8.964 0 1 0 8.965 8.965 8.962 8.962 0 0 0-8.965-8.965zM179.97 328.99a8.968 8.968 0 0 0-6.34 15.305 8.968 8.968 0 0 0 15.305-6.34c0-4.95-4.016-8.965-8.965-8.965zM239.62 337.95a8.965 8.965 0 1 1-17.93 0 8.965 8.965 0 0 1 17.93 0M290.31 337.95a8.965 8.965 0 1 1-17.93 0 8.965 8.965 0 0 1 17.93 0"
  })), _path2 || (_path2 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M176.14 90.605a7.704 7.704 0 0 0-7.703 7.707v15.559h-23.5c-8.235.012-16.133 3.285-21.957 9.11s-9.098 13.722-9.11 21.956v222.12c.012 8.239 3.286 16.133 9.11 21.957s13.723 9.098 21.957 9.11h222.12c8.238-.012 16.133-3.285 21.957-9.11s9.098-13.719 9.11-21.957v-222.12c-.012-8.234-3.286-16.133-9.11-21.957s-13.72-9.097-21.957-9.109H343.56V98.312a7.708 7.708 0 0 0-15.414 0v15.559h-144.3V98.312a7.708 7.708 0 0 0-7.707-7.707zm190.92 292.11H144.94a15.652 15.652 0 0 1-11.062-4.59 15.664 15.664 0 0 1-4.59-11.062v-194.34l253.43.004v194.34a15.646 15.646 0 0 1-4.59 11.062 15.647 15.647 0 0 1-11.062 4.59zm15.652-237.78v12.371h-253.43v-12.371a15.652 15.652 0 0 1 4.59-11.062 15.654 15.654 0 0 1 11.062-4.59h222.12a15.662 15.662 0 0 1 11.062 4.59 15.654 15.654 0 0 1 4.59 11.062z"
  })));
};
/* harmony default export */ __webpack_exports__["Z"] = (SvgCalendarIcon);

/***/ }),

/***/ 96963:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

/* harmony default export */ __webpack_exports__["Z"] = ({"src":"https://images-prod.forumm.to/2986/_next/static/media/default-thumbnail.e3eaaa42.png","height":1055,"width":3000,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAADCAYAAACuyE5IAAAAEklEQVR4nGP0XHrxPwMeQLkCAAg1CD6gtSBNAAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":3});

/***/ }),

/***/ 52987:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Media; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./public/images/Speaker.svg
var _defs, _g, _path, _g2, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgSpeaker = function SvgSpeaker(props) {
  return /*#__PURE__*/react.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 500,
    viewBox: "0 0 375 375",
    height: 500
  }, props), _defs || (_defs = /*#__PURE__*/react.createElement("defs", null, /*#__PURE__*/react.createElement("clipPath", {
    id: "Speaker_svg__a"
  }, /*#__PURE__*/react.createElement("path", {
    d: "M113 7.5h149V156H113Zm0 0"
  })), /*#__PURE__*/react.createElement("clipPath", {
    id: "Speaker_svg__b"
  }, /*#__PURE__*/react.createElement("path", {
    d: "M0 290h375v77.5H0Zm0 0"
  })))), _g || (_g = /*#__PURE__*/react.createElement("g", {
    clipPath: "url(#Speaker_svg__a)"
  }, /*#__PURE__*/react.createElement("path", {
    d: "M187.578 137.703c15.527 0 29.598-6.297 39.777-16.476 10.18-10.18 16.48-24.25 16.48-39.778 0-15.531-6.3-29.597-16.48-39.777s-24.242-16.477-39.777-16.477-29.598 6.297-39.781 16.477c-10.176 10.176-16.473 24.242-16.473 39.777 0 15.531 6.297 29.602 16.473 39.781 10.183 10.18 24.246 16.473 39.781 16.473Zm52.188-4.07c-13.36 13.36-31.813 21.62-52.188 21.62-20.379 0-38.828-8.257-52.187-21.616-13.356-13.356-21.618-31.809-21.618-52.188s8.262-38.832 21.618-52.187c13.359-13.356 31.808-21.617 52.187-21.617 20.375 0 38.832 8.261 52.188 21.62 13.355 13.36 21.617 31.81 21.617 52.184 0 20.375-8.262 38.824-21.617 52.184"
  }))), _path || (_path = /*#__PURE__*/react.createElement("path", {
    d: "M240.64 170.023a86.357 86.357 0 0 1-22.109 12.114 85.853 85.853 0 0 1-29.844 5.343c-10.312 0-20.44-1.867-29.996-5.414a86.194 86.194 0 0 1-22.308-12.308 70.013 70.013 0 0 0-31.59 23.66c-8.688 11.625-13.75 25.953-13.75 41.219v27.484h79.77v17.55h-97.32v-45.034c0-19.153 6.343-37.125 17.245-51.707a87.613 87.613 0 0 1 44.903-31.403l4.562-1.375 3.629 3.121c6.281 5.403 13.375 9.586 20.961 12.407 7.496 2.785 15.566 4.25 23.894 4.25 8.25 0 16.29-1.465 23.81-4.25a68.885 68.885 0 0 0 20.886-12.27l3.86-3.297 4.777 1.723c19.636 7.078 34.023 17.297 43.835 31.082 9.774 13.738 14.793 30.707 15.735 51.352v.375l.023 36.253.004 8.774h-96.39v-17.55h78.898l-.02-27.095c-.785-17.214-4.773-31.093-12.507-41.96-6.965-9.786-17.145-17.376-30.957-23.044"
  })), _g2 || (_g2 = /*#__PURE__*/react.createElement("g", {
    clipPath: "url(#Speaker_svg__b)"
  }, /*#__PURE__*/react.createElement("path", {
    d: "M357.531 307.938H17.605v41.937h339.926ZM8.832 290.387h366.25v77.039H.055v-77.04h8.777"
  }))), _path2 || (_path2 = /*#__PURE__*/react.createElement("path", {
    d: "M181.742 240.8c-3.34-2.042-5.594-5.491-5.918-9.495l-1.36-16.7c-.55-6.835 4.56-12.894 11.403-13.445 6.856-.558 12.895 4.574 13.45 11.43l1.359 16.691c.387 4.797-2.082 9.25-6.125 11.617l-.559 49.692h-12.89l.64-49.79",
    fillRule: "evenodd"
  })));
};
/* harmony default export */ var Speaker = (SvgSpeaker);
// EXTERNAL MODULE: ./components/base/Box.tsx
var Box = __webpack_require__(51773);
// EXTERNAL MODULE: ./components/base/Text.tsx
var Text = __webpack_require__(40517);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
;// CONCATENATED MODULE: ./public/percentage-placeholder.png
/* harmony default export */ var percentage_placeholder = ({"src":"https://images-prod.forumm.to/2986/_next/static/media/percentage-placeholder.35910295.png","height":91,"width":96,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAYAAADED76LAAAArUlEQVR42mMAAbncNiYGKNj46DsfjL3z5T+geHojVNJWOnH62uI9b//n7Hj5rxyI7RhgAKiInyGtoUkmt00KJgRUkL/t+R9nmIJwIDZmAIKQ7kVcMEV73/+vZQABpvTGZKAJAozpjZpAOhBokhcDEHTtuZgNMyEaiHWhbDmGlHpxz5bZ7AwhRdUwBSJAXAfUDfcBkJ0EMgkkyQxVpA60qhlIFzEAaaB1/gwMDAwAIs4/+IaHFp0AAAAASUVORK5CYII=","blurWidth":8,"blurHeight":8});
// EXTERNAL MODULE: ./libs/useTheme.ts + 1 modules
var useTheme = __webpack_require__(5779);
// EXTERNAL MODULE: ./public/images/default-thumbnail.png
var default_thumbnail = __webpack_require__(96963);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./public/images/CalendarIcon.svg
var CalendarIcon = __webpack_require__(31554);
;// CONCATENATED MODULE: ./public/images/Edit.svg
var Edit_g;
function Edit_extends() { Edit_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return Edit_extends.apply(this, arguments); }

var SvgEdit = function SvgEdit(props) {
  return /*#__PURE__*/react.createElement("svg", Edit_extends({
    width: "512pt",
    height: "512pt",
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), Edit_g || (Edit_g = /*#__PURE__*/react.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/react.createElement("path", {
    d: "M299.36 101.7 49.9 351.16a16.023 16.023 0 0 0-4.223 7.457l-29.215 117.54a16.022 16.022 0 0 0 4.223 15.168c3.984 3.984 9.762 5.55 15.168 4.223l117.54-29.2a16.06 16.06 0 0 0 7.457-4.222l249.46-249.46zM473.02 38.992c-30.594-30.594-80.352-30.594-110.96 0L321.962 79.09l110.96 110.96 40.098-40.098c30.594-30.609 30.594-80.367 0-110.96z"
  }))));
};
/* harmony default export */ var Edit = (SvgEdit);
// EXTERNAL MODULE: ./libs/currencies.ts
var currencies = __webpack_require__(30530);
// EXTERNAL MODULE: ./libs/Utility/util.ts + 3 modules
var util = __webpack_require__(53510);
// EXTERNAL MODULE: ./components/ui/MediaThumbnail.tsx
var MediaThumbnail = __webpack_require__(26052);
// EXTERNAL MODULE: ./libs/Utility/parsers.tsx
var parsers = __webpack_require__(40654);
// EXTERNAL MODULE: ./libs/Auth/useAuth.ts + 3 modules
var useAuth = __webpack_require__(24499);
;// CONCATENATED MODULE: ./components/landing/Media.tsx

















function MediaCard(param) {
    let { className , url , image , title , subtitle , description , isDonation , type ="LANDING" , organization , banner , startTime , endTime , timeZone , eventId , canEdit , isSpeaker =false , size , attendees , donors , isPublished , goal , raised , currency  } = param;
    const router = (0,next_router.useRouter)();
    const { theme  } = (0,useTheme/* useTheme */.Fg)();
    const contrastColor = (0,util/* getContrastColor */.RN)(theme.highlightColour);
    const { push  } = (0,next_router.useRouter)();
    const [bgColor, setBgColor] = (0,react.useState)(theme.foregroundColour);
    const [percentage, setPercentage] = (0,react.useState)(0);
    const [mediaType, setMediaType] = (0,react.useState)(undefined);
    const isDarkTheme = theme.type === "DARK";
    const textColorClass = "text-forumm-text-deep-teal-blue";
    const { profile , isAdmin , isOrganizer  } = (0,useAuth/* useAuth */.aC)();
    (0,react.useEffect)(()=>{
        if (image) {
            (0,parsers/* getMediaType */.V4)(image).then((type)=>setMediaType(type));
        }
    }, [
        image
    ]);
    (0,react.useEffect)(()=>{
        if (raised && goal) {
            setPercentage(Math.min(raised / goal * 100, 100));
        }
    }, [
        goal,
        percentage,
        raised
    ]);
    (0,react.useEffect)(()=>{
        if (theme.type === "DARK") {
            setBgColor(theme.mediaBackgroundColor);
        } else {
            setBgColor(theme.foregroundColour);
        }
    }, [
        theme.foregroundColour,
        theme.mediaBackgroundColor,
        theme.type
    ]);
    const handleNavigation = ()=>{
        if (!url) return;
        if ((0,parsers/* isValidUrl */.jv)(url)) (0,util/* openInNewTab */.YQ)(url);
        else router.push(url);
    };
    const handleEdit = (e)=>{
        e.stopPropagation();
        router.push("/create-event?id=".concat(eventId));
    };
    // TODO: Hardcoded overwrite for Launch Fundraiser
    if (eventId === "7f31134c-bc71-490a-9705-7e0dfa085f8e") {
        raised = (raised !== null && raised !== void 0 ? raised : 0) + 8500;
        donors = (donors !== null && donors !== void 0 ? donors : 0) + 2;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
        onClick: handleNavigation,
        className: "relative rounded-xl my-6 ml-2 mx-[22px] cursor-pointer w-[85%] max-w-[1500px] sm:w-[23%] pb-6 border border-gray-200 shadow-md ".concat(className),
        style: {
            backgroundColor: bgColor
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                className: "w-full relative square rounded-t-xl overflow-hidden",
                children: mediaType === "VIDEO" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(MediaThumbnail/* MediaThumbnail */.U, {
                    className: "absolute top-0 left-0 w-full h-full rounded-t-x",
                    media: image
                }, "") : /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                    className: "absolute top-0 left-0 w-full h-full rounded-t-x",
                    style: {
                        backgroundImage: "url(".concat(image || default_thumbnail/* default.src */.Z.src, ")"),
                        backgroundSize: "cover",
                        backgroundRepeat: "no-repeat",
                        backgroundPosition: "center",
                        backgroundColor: theme.backgroundColour
                    }
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                className: "pb-6 px-2 pt-4 flex flex-col",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                        className: "-mt-24 rounded-xl p-4 shadow-md",
                        style: {
                            background: isDarkTheme ? "rgba(0, 0, 0, 0.7)" : "rgba(255, 255, 255, 0.6)",
                            backdropFilter: "blur(5px)",
                            WebkitBackdropFilter: "blur(5px)"
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                className: "text-xl font-semibold pb-1 line-clamp-2 mb-4 min-h-[4rem] leading-normal",
                                children: title
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                className: " pb-4",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                                    className: "text-gray-200 flex items-center mr-4 text-sm",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(MediaThumbnail/* MediaThumbnail */.U, {
                                            className: "inline-block h-7 w-7 object-cover mr-2 rounded-full",
                                            media: banner
                                        }, ""),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "".concat(textColorClass, " font-semibold truncate"),
                                            children: organization
                                        })
                                    ]
                                })
                            }),
                            subtitle && /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                className: "pb-6 text-sm font-medium line-clamp-2",
                                children: subtitle
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                className: "text-sm line-clamp-5 h-14 min-h-[5rem] !text-gray-400",
                                children: description || ""
                            }),
                            type !== "LANDING" && type !== "FUNDRAISER" && type !== "CONTENT" && type !== "PARTNER" && organization && (isOrganizer && (profile === null || profile === void 0 ? void 0 : profile.company) === organization || isAdmin) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                className: "py-4 text-sm ".concat(textColorClass),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                        children: attendees
                                    }),
                                    " Participants"
                                ]
                            }),
                            type === "FUNDRAISER" && /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                className: "py-4 ".concat(textColorClass, " text-sm"),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                        children: donors
                                    }),
                                    " Donors"
                                ]
                            }),
                            type !== "LANDING" && type !== "FUNDRAISER" && type !== "CONTENT" && type !== "PARTNER" && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                                className: "text-xs cursor-pointer flex items-center ",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CalendarIcon/* default */.Z, {
                                        className: "w-8 h-8 ",
                                        fill: theme === null || theme === void 0 ? void 0 : theme.textColour,
                                        style: {
                                            marginLeft: "-0.5rem"
                                        }
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        className: "flex-1 !text-gray-400",
                                        children: [
                                            (0,util/* formatEventDateTime */.ep)(startTime, "MMM DD, h:mmA", {
                                                eventType: type,
                                                timeZone
                                            }),
                                            " ",
                                            " - ",
                                            (0,util/* formatEventDateTime */.ep)(endTime, "MMM DD, h:mmA", {
                                                eventType: type,
                                                timeZone
                                            })
                                        ]
                                    })
                                ]
                            }),
                            type === "FUNDRAISER" && !(isOrganizer || isAdmin) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                className: "h-[32px]"
                            }),
                            type === "FUNDRAISER" && (isOrganizer || isAdmin) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                                style: {
                                    opacity: goal || raised ? 1 : 0
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                                        className: "flex justify-between text-sm",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                className: "".concat(textColorClass),
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                                        children: "".concat(currencies/* default */.Z[currency !== null && currency !== void 0 ? currency : "GBP"].symbol).concat(!!raised && raised % 1 === 0 ? raised : raised === null || raised === void 0 ? void 0 : raised.toFixed(2))
                                                    }),
                                                    " ",
                                                    "Raised"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "".concat(textColorClass),
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                                    children: "".concat(currencies/* default */.Z[currency !== null && currency !== void 0 ? currency : "GBP"].symbol).concat(goal)
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                        className: "mt-1 bg-forumm-white ".concat(isDarkTheme ? "" : "border border-forumm-menu-border", " rounded-xl"),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                            className: "h-2 rounded-xl ".concat(textColorClass, " bg-forumm-blue-light"),
                                            style: {
                                                width: "".concat(Math.min(percentage, 100), "%")
                                            }
                                        })
                                    })
                                ]
                            }),
                            isDonation && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                                className: "flex items-center mt-6 gap-6",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        src: percentage_placeholder,
                                        alt: "Donation Percentage",
                                        width: 76,
                                        height: 76
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                                        className: "flex-row opacity-0",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                children: "€20,000"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                children: "Raised by 190 supporters"
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                        className: "absolute bottom-0 left-0 flex justify-between w-full",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                show: !!canEdit,
                                className: "bg-forumm-blue text-white rounded p-2 px-3 md:px-4 rounded-tl-none rounded-br-none flex items-center -mb-[1px] -mr-[1px] rounded-tr-xl rounded-bl-xl shadow-md text-xs sm:text-sm ".concat(isDarkTheme ? "" : "border border-forumm-menu-border", " ").concat(isPublished ? "bg-green-700" : "bg-yellow-700"),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    style: {
                                        color: contrastColor
                                    },
                                    children: isPublished ? "Published" : "Draft"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                                show: isSpeaker,
                                className: "bg-forumm-blue text-white rounded p-2 px-3 md:px-4 rounded-tl-none rounded-br-none flex items-center -mb-[1px] -mr-[1px] rounded-tr-xl rounded-bl-xl shadow-md text-xs sm:text-sm ".concat(isDarkTheme ? "" : "border border-forumm-menu-border"),
                                style: {
                                    backgroundColor: theme.highlightColour
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Speaker, {
                                        className: "h-4 w-4 inline-block mr-2 text-FFFFFF"
                                    }),
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        style: {
                                            color: contrastColor
                                        },
                                        children: "Speaker"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                show: !!type && [
                                    "PARTNER",
                                    "CONTENT"
                                ].includes(type),
                                onClick: handleNavigation,
                                className: "ml-auto py-2 cursor-pointer bg-forumm-blue text-white rounded px-3 md:px-4 rounded-bl-none rounded-tr-none flex items-center -mb-[1px] -mr-[1px] rounded-br-xl rounded-tl-xl shadow-md shadow-md text-xs sm:text-sm ".concat(isDarkTheme ? "" : "border border-forumm-menu-border", " hover:animate-heartbeat"),
                                style: {
                                    backgroundColor: theme.highlightColour
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    style: {
                                        color: contrastColor
                                    },
                                    children: "View"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                                show: !!canEdit,
                                onClick: handleEdit,
                                className: "cursor-pointer bg-forumm-blue text-white rounded px-3 md:px-4 rounded-bl-none rounded-tr-none flex items-center -mb-[1px] -mr-[1px] rounded-br-xl rounded-tl-xl shadow-md shadow-md text-xs sm:text-sm ".concat(isDarkTheme ? "" : "border border-forumm-menu-border", " hover:animate-heartbeat"),
                                style: {
                                    backgroundColor: theme.highlightColour
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Edit, {
                                        className: "h-4 w-4 inline-block mr-2"
                                    }),
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        style: {
                                            color: contrastColor
                                        },
                                        children: "Edit"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
/* harmony default export */ var Media = (MediaCard);


/***/ }),

/***/ 30530:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

const currencies = {
    CAD: {
        symbol: "$",
        name: "Canadian Dollar"
    },
    USD: {
        symbol: "$",
        name: "US Dollar"
    },
    EUR: {
        symbol: "€",
        name: "Euro"
    },
    GBP: {
        symbol: "\xa3",
        name: "British Pound"
    }
};
/* harmony default export */ __webpack_exports__["Z"] = (currencies);


/***/ })

}]);